const translations = {
    casLabel: 'CAS',
    classification: 'Classification',
    cropRates: 'Crop Rates',
    documents: 'Documents',
    epaNumber: 'EPA Number',
    formulation: 'Formulation',
    ingredients: 'Ingredients',
    manufacturer: 'Manufacturer',
    modeOfAction: 'Mode of Action',
    pests: 'Pests',
    ppe: 'PPE',
    ppeReentry: 'PPE Reentry',
    rainfastness: 'Rainfastness (hrs)',
    rei: 'REI',
    reviewFormulation: 'Review formulation',
    signalWord: 'Signal Word',
    weatherRestrictions: 'Weather Restrictions'
};

export default translations;
